import { render, staticRenderFns } from "./indexListHermes.vue?vue&type=template&id=1c05b6d8&scoped=true"
import script from "./indexListHermes.vue?vue&type=script&lang=js"
export * from "./indexListHermes.vue?vue&type=script&lang=js"
import style0 from "./indexListHermes.vue?vue&type=style&index=0&id=1c05b6d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05b6d8",
  null
  
)

export default component.exports